<script setup lang="ts">
import { userInjectionKey, guest } from '#shared'
import { useQuery } from '@tanstack/vue-query'
import { computed, inject, unref } from 'vue'
import { getChatQueryOptions, useChatId } from '#entities/chat'
import MessageEditorBan from './states/message-editor-ban.vue'
import MessageEditorDefault from './states/message-editor-default.vue'
import MessageEditorLoading from './states/message-editor-loading.vue'
import MessageEditorLoginRequired from './states/message-editor-login-required.vue'

const { variant = 'regular' } = defineProps<{ variant?: 'regular' | 'compact' }>()

const currentUser = inject(userInjectionKey)
const chatId = useChatId()
const chatQuery = useQuery(getChatQueryOptions(chatId.value))
const chat = chatQuery.data

const isLoading = computed(() => {
  const currentUserVal = unref(currentUser)
  return !currentUserVal
})

const isLoginRequired = computed(() => {
  const currentUserVal = unref(currentUser)
  return currentUserVal === guest
})

const ban = computed(() => {
  const currentUserVal = unref(currentUser)
  if (currentUserVal === guest) return null
  return currentUserVal?.bans.find(ban => ban.chatId === chatId.value) ?? null
})
</script>

<template>
  <MessageEditorLoading v-if="isLoading" :variant="variant" />

  <div v-else-if="chat?.isProtected && !chat.signedAt" />

  <MessageEditorLoginRequired v-else-if="isLoginRequired" :variant="variant" />

  <MessageEditorBan v-else-if="ban" :variant="variant" :ban="ban" />

  <MessageEditorDefault v-else :variant="variant" />
</template>
